/* =========================================================================
   LL — Carrello collana personalizzata

   1. rimuove i ciondoli rimasti orfani quando il cliente elimina la collana
      a cui erano collegati;
   2. nasconde le righe dei ciondoli (_ll_linked_to), se il tema non lo fa già,
      e scrive sulla riga della collana il prezzo del gruppo. È solo
      presentazione: il totale carrello lo calcola Shopify e non cambia;
   3. aggiunge un riquadro apribile con l'anteprima della collana composta.

   ABBINAMENTO RIGHE ↔ ARTICOLI
   Alcuni temi mostrano tutte le righe, altri saltano già gli articoli
   collegati. Provo quindi due abbinamenti: prima tutti gli articoli, poi solo
   quelli non collegati. Vince il primo che combacia per numero e per link
   prodotto. Se nessuno combacia lo script non tocca niente.
   ========================================================================= */
(function () {
  var CSS_ID = 'llnp-cart-css';
  var CLEAN_FLAG = 'llnp_clean_ts';   // evita cicli di pulizia/ricarica
  var CLEAN_COOLDOWN = 8000;          // ms

  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function injectStyles() {
    if (document.getElementById(CSS_ID)) return;
    var s = document.createElement('style');
    s.id = CSS_ID;
    s.textContent = [
      '.llnp{margin-top:10px}',
            '.llnp__toggle{display:inline-block;margin:6px 0 4px;padding:9px 16px;border:1px solid currentColor;border-radius:3px;background:none;font:inherit;font-size:13.5px;font-weight:600;text-decoration:none;cursor:pointer}',
      '.llnp__box{margin-top:10px;padding:12px;border:1px solid rgba(0,0,0,.10);background:rgba(245,245,245,.6);max-width:320px}',
      '.llnp__stage{position:relative;width:100%}',
      '.llnp__stage img.llnp__base{display:block;width:100%;height:auto}',
      '.llnp__layer{position:absolute;inset:0}',
      '.llnp__layer img{position:absolute}',
      '.llnp__link{display:inline-block;margin-top:10px;font-size:12px;text-decoration:underline}',
      '.llnp-hidden-row{display:none !important}'
    ].join('');
    document.head.appendChild(s);
  }

  function containers() {
    var list = [];
    ['#main-cart-items', 'cart-items', 'cart-drawer-items', '.cart-items'].forEach(function (sel) {
      Array.prototype.forEach.call(document.querySelectorAll(sel), function (el) {
        if (list.indexOf(el) === -1) list.push(el);
      });
    });
    if (!list.length) list.push(document);
    return list;
  }

  function rowsIn(container) {
    return Array.prototype.slice.call(container.querySelectorAll('.cart-item, [data-cart-item]'));
  }

  function rowMatches(row, item) {
    var a = row.querySelector('a[href*="/products/"]');
    if (!a) return true; // niente link: mi affido alla posizione
    var href = a.getAttribute('href') || '';
    if (item.handle && href.indexOf('/' + item.handle) !== -1) return true;
    if (item.variant_id && href.indexOf('variant=' + item.variant_id) !== -1) return true;
    return false;
  }

  // Restituisce la lista di articoli che corrisponde alle righe visibili
  function pairing(cart, rows) {
    var visible = cart.items.filter(function (it) {
      return !(it.properties && it.properties._ll_linked_to);
    });
    var lists = [cart.items, visible];
    for (var i = 0; i < lists.length; i++) {
      var L = lists[i];
      if (!L.length || L.length !== rows.length) continue;
      var ok = L.every(function (item, j) { return rowMatches(rows[j], item); });
      if (ok) return L;
    }
    return null;
  }

  function rowDetails(row) {
    var name = row.querySelector('.cart-item__name');
    return row.querySelector('.cart-item__details') ||
           (name && name.parentElement) ||
           row;
  }

  /* Sostituisce il prezzo mostrato nella riga senza dipendere dalle classi del
     tema: scorre i nodi di TESTO e riscrive quelli che valgono oldCents. */
  function setRowPrice(row, oldCents, newCents) {
    var wanted = String(oldCents);
    var newTxt = (newCents / 100).toFixed(2).replace('.', ',');

    function centsIn(text) {
      var m = String(text).replace(/\s/g, '').match(/(\d+[.,]\d{2})/);
      if (!m) return null;
      return String(Math.round(parseFloat(m[1].replace(',', '.')) * 100));
    }

    var walker = document.createTreeWalker(row, NodeFilter.SHOW_TEXT, null, false);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach(function (n) {
      var t = n.nodeValue;
      if (!t || !t.trim() || t.length > 40) return;
      if (centsIn(t) !== wanted) return;
      n.nodeValue = t.replace(/\d+[.,]\d{2}/, newTxt);
    });
  }

  /* ---------------------------------------------------------------------
     PULIZIA ORFANI — solo chiavi "NCK-": bracciale e cover usano un aggancio
     diverso e non vanno toccati.
     --------------------------------------------------------------------- */
  function bundleKeys(cart) {
    var parents = {};
    cart.items.forEach(function (it) {
      var k = it.properties && it.properties._ll_bundle_key;
      if (k) parents[k] = true;
    });
    return parents;
  }

  function findOrphans(cart) {
    var parents = bundleKeys(cart);
    var orphans = [];
    cart.items.forEach(function (it) {
      var k = it.properties && it.properties._ll_linked_to;
      if (!k || String(k).indexOf('NCK-') !== 0) return;
      if (!parents[k]) orphans.push(it.key);
    });
    return orphans;
  }

  function recentlyCleaned() {
    try {
      var ts = parseInt(sessionStorage.getItem(CLEAN_FLAG) || '0', 10);
      return ts && (Date.now() - ts) < CLEAN_COOLDOWN;
    } catch (e) { return false; }
  }

  function markCleaned() {
    try { sessionStorage.setItem(CLEAN_FLAG, String(Date.now())); } catch (e) {}
  }

  function removeOrphans(keys) {
    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { return r.ok ? r.json() : null; });
  }

  /* Il link alla pagina anteprima non dipende dalla geometria: viene mostrato
     comunque. Il disegno inline compare solo se necklace-geometry.js c'è. */
  function buildPreview(item) {
    var props = item.properties || {};
    var url = props['_Anteprima collana'];

    var charms = [];
    try { charms = JSON.parse(props._ll_charms || '[]'); } catch (e) { charms = []; }
    if (!Array.isArray(charms)) charms = [];

    if (!url && !charms.length) return null;

    var geo = null;
    try { geo = JSON.parse(props._ll_chain); } catch (e) {}
    var canDraw = !!(window.LLNecklace && charms.length);
    if (canDraw && !geo) geo = window.LLNecklace.resolve('maxi', null);

    var wrap = document.createElement('div');
    wrap.className = 'llnp';

    var box = document.createElement('div');
    box.className = 'llnp__box';
    box.style.display = 'none';

    var layer = null;
    if (canDraw) {
      var stage = document.createElement('div');
      stage.className = 'llnp__stage';

      var base = document.createElement('img');
      base.className = 'llnp__base';
      base.src = (item.featured_image && item.featured_image.url) || item.image || '';
      base.alt = '';

      layer = document.createElement('div');
      layer.className = 'llnp__layer';

      stage.appendChild(base);
      stage.appendChild(layer);
      box.appendChild(stage);
    }

    if (url) {
      var a = document.createElement('a');
      a.className = 'llnp__link';
      a.href = url;
      a.target = '_blank';
      a.rel = 'noopener';
      a.textContent = 'Apri a schermo intero';
      box.appendChild(a);
    }

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'llnp__toggle';
    toggle.textContent = 'Vedi anteprima collana';
    toggle.addEventListener('click', function () {
      var open = box.style.display === 'none';
      box.style.display = open ? 'block' : 'none';
      toggle.textContent = open ? 'Nascondi anteprima' : 'Vedi anteprima collana';
      if (open && canDraw) window.LLNecklace.paint(layer, charms, geo, false);
    });

    wrap.appendChild(toggle);
    wrap.appendChild(box);
    return wrap;
  }

  function apply(cart) {
    var parents = bundleKeys(cart);

    var addons = {};
    cart.items.forEach(function (it) {
      var k = it.properties && it.properties._ll_linked_to;
      if (k && parents[k]) addons[k] = (addons[k] || 0) + it.final_line_price;
    });

    containers().forEach(function (container) {
      var rows = rowsIn(container);
      if (!rows.length) return;

      var list = pairing(cart, rows);
      if (!list) return;

      list.forEach(function (item, i) {
        var row = rows[i];
        var props = item.properties || {};

        // riga ciondolo: nascosta solo se la sua collana è nel carrello
        var linked = props._ll_linked_to;
        if (linked) {
          if (parents[linked]) row.classList.add('llnp-hidden-row');
          return;
        }

        // riga collana: prezzo del gruppo
        var key = props._ll_bundle_key;
        if (key && addons[key]) {
          setRowPrice(row, item.final_line_price, item.final_line_price + addons[key]);
        }

        // riquadro anteprima
                var isNecklace = !!props['_Anteprima collana'] ||
                         (props._ll_charms && String(props._ll_bundle_key || '').indexOf('NCK-') === 0);
        if (isNecklace) {
          var target = rowDetails(row);
          if (target && !target.querySelector('.llnp')) {
                      var el = buildPreview(item);
            if (el) {
              var title = row.querySelector('.cart-item__name');
              if (title) title.insertAdjacentElement('afterend', el);
              else target.appendChild(el);
            }
          }
        }
      });
    });
  }

  function run() {
    injectStyles();
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) return;

        var orphans = findOrphans(cart);
        if (orphans.length && !recentlyCleaned()) {
          markCleaned();
          removeOrphans(orphans).then(function (updated) {
            if (!updated) { apply(cart); return; }
            if (location.pathname.indexOf('/cart') === 0) {
              window.location.reload();
            } else {
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              setTimeout(function () { apply(updated); }, 400);
            }
          });
          return;
        }

        apply(cart);
      })
      .catch(function () {});
  }

  function boot() {
    run();
    containers().forEach(function (host) {
      if (!('MutationObserver' in window) || host === document) return;
      var t;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(run, 250);
      }).observe(host, { childList: true, subtree: true });
    });
    document.addEventListener('cart:refresh', function () { setTimeout(run, 250); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();